const initialValue = {
    groups: [],
    groupTime: 0,
};

export default function groupReducer(state = initialValue, action) {
    switch (action.type) {
        case "GET_ALL_GROUPS":
            const newObject = action.payload.slice(0);
            return {...state, groups: newObject};
        case "GET_GROUP_MODIFICATION_TIME":
            return {...state, groupTime: action.payload};
        case "CHANGE_FARM":
        case "USER_LOGOUT_FULFILLED": {
            return initialValue;
        }
        default:
            return state;
    }
}
